var _circle, _circle2, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJimmy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 200,
    viewBox: "0 0 249 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 57.3691,
    r: 18.5,
    fill: "#7544B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 57.3691,
    r: 18.5,
    fill: "#7544B2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_91_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.464 139.781C155.128 141.319 158.578 140.415 159.701 137.552C161.387 133.249 162.262 128.654 162.262 124C162.262 117.482 160.546 111.079 157.287 105.435C154.028 99.7899 149.341 95.1026 143.696 91.8437C138.052 88.5847 131.649 86.8691 125.131 86.8691C118.613 86.8691 112.21 88.5847 106.565 91.8437C100.921 95.1026 96.2335 99.7899 92.9746 105.435C89.7157 111.079 88 117.482 88 124C88 128.654 88.8747 133.249 90.5613 137.552C91.6839 140.415 95.1341 141.319 97.7981 139.781C100.462 138.243 101.309 134.842 100.373 131.912C99.5587 129.365 99.1393 126.696 99.1393 124C99.1393 119.438 100.34 114.955 102.622 111.004C104.903 107.053 108.184 103.772 112.135 101.491C116.086 99.2093 120.568 98.0083 125.131 98.0083C129.693 98.0083 134.176 99.2093 138.127 101.491C142.078 103.772 145.359 107.053 147.64 111.004C149.922 114.955 151.123 119.438 151.123 124C151.123 126.696 150.703 129.365 149.889 131.912C148.953 134.842 149.8 138.243 152.464 139.781Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.464 139.781C155.128 141.319 158.578 140.415 159.701 137.552C161.387 133.249 162.262 128.654 162.262 124C162.262 117.482 160.546 111.079 157.287 105.435C154.028 99.7899 149.341 95.1026 143.696 91.8437C138.052 88.5847 131.649 86.8691 125.131 86.8691C118.613 86.8691 112.21 88.5847 106.565 91.8437C100.921 95.1026 96.2335 99.7899 92.9746 105.435C89.7157 111.079 88 117.482 88 124C88 128.654 88.8747 133.249 90.5613 137.552C91.6839 140.415 95.1341 141.319 97.7981 139.781C100.462 138.243 101.309 134.842 100.373 131.912C99.5587 129.365 99.1393 126.696 99.1393 124C99.1393 119.438 100.34 114.955 102.622 111.004C104.903 107.053 108.184 103.772 112.135 101.491C116.086 99.2093 120.568 98.0083 125.131 98.0083C129.693 98.0083 134.176 99.2093 138.127 101.491C142.078 103.772 145.359 107.053 147.64 111.004C149.922 114.955 151.123 119.438 151.123 124C151.123 126.696 150.703 129.365 149.889 131.912C148.953 134.842 149.8 138.243 152.464 139.781Z",
    stroke: "#7544B2",
    strokeWidth: 22.058,
    mask: "url(#path-3-inside-1_91_2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJimmy);
export default __webpack_public_path__ + "static/media/jimmy.409354091d4041e9881c7ccb74f88281.svg";
export { ForwardRef as ReactComponent };